<template>
    <div :class="containerClass">
        <div class="p-inplace-display" :tabindex="$attrs.tabindex||'0'" v-if="!d_active" @click="open" @keydown.enter="open">
            <slot name="display"></slot>
        </div>
        <div class="p-inplace-content" v-else>
            <IPButton class=" p-button-outlined p-button-success" v-if="closable" :icon="`pi ${closeIcon}`" @click="close"></IPButton>
            <slot name="content"></slot>
            <IPButton class=" p-button-danger p-button-outlined" v-if="cancelble" :icon="`pi ${cancelIcon}`" @click="cancel"></IPButton>
        </div>
    </div>
</template>

<script>
import Button from '../button/Button';

export default {
    props: {
        closable: {
            type: Boolean,
            default: false
        },
        cancelble: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        closeIcon: {
            type: String,
            default: "pi-times"
        },
        cancelIcon: {
            type: String,
            default: "pi-times"
        }
    },
    watch: {
        active(newValue) {
            this.d_active = newValue;
        }
    },
    data() {
        return {
            d_active: this.active
        }
    },
    methods: {
        open(event) {
            this.$emit('open', event);
            this.d_active = true;
            this.$emit('update:active', true);
        },
        close(event) {
            this.$emit('close', event);
            this.d_active = false;
            this.$emit('update:active', false);
        },
        cancel(event) {
            this.$emit('cancel', event);
            this.d_active = false;
            this.$emit('update:active', false);
        }
    },
    computed: {
        containerClass() {
            return ['p-inplace p-component', {'p-inplace-closable': this.closable}];
        }
    },
    components: {
        'IPButton': Button
    }
}
</script>

<style>
.p-inplace .p-inplace-display {
    /*display: inline; not work for me*/
    cursor: pointer;
}

.p-inplace .p-inplace-content {
    display: inline;
}

.p-fluid .p-inplace.p-inplace-closable .p-inplace-content {
    display: flex;
}

.p-fluid .p-inplace.p-inplace-closable .p-inplace-content > .p-inputtext {
    flex: 1 1 auto;
    width: 1%;
}
</style>
